import { render, staticRenderFns } from "./dialogbox.vue?vue&type=template&id=5a72620a&scoped=true"
import script from "./dialogbox.vue?vue&type=script&lang=js"
export * from "./dialogbox.vue?vue&type=script&lang=js"
import style0 from "./dialogbox.vue?vue&type=style&index=0&id=5a72620a&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a72620a",
  null
  
)

export default component.exports